/**
 * @description: 缺歌反馈
 * @author: hwx
 */
<template>
	<div class="lack-manage-wrap">
		<div class="lack-list" v-show="showList">
			<h1>缺歌反馈</h1>
			<div class="row">
				<label class="list-label-2">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="lack_shop"></select>
				</div>
				<label class="list-label-4">处理状态:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="lack_status">
						<option value="0">全部</option>
						<option value="-2">待客服确认</option>
						<option value="-1">未处理</option>
						<option value="1">处理完成</option>
						<option value="2">不予处理</option>
						<option value="3">制作中</option>
						<option value="4">已删除</option>
					</select>
				</div>
				<div class="col-md-1 ct-col lack-tit-sel">
					<select class="form-control" ref="query_sel">
						<option value="song_name">歌曲名称</option>
						<option value="song_player">歌星姓名</option>
					</select>
				</div>
				<div class="col-md-2 lack-con-val">
					<input type="text" class="form-control" v-model="query_val" :placeholder="query_phd">
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryList">查询</button>
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="lackAdd">新增缺歌</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="lack_list"></table>
			</div>
		</div>
		<!-- 新增缺歌 -->
		<div class="lack-add" v-show="!showList">
			<div class="page-tit">新增缺歌</div>
			<div class="row">
				<label class="ctr-label-left">
					<span>门店名称</span>
					<i>*</i>
				</label>
				<div class="col-md-5 ct-col">
					<select class="form-control" ref="edit_shop"></select>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">
					<span>歌曲名称</span>
					<i>*</i>
				</label>
				<div class="col-md-5">
					<input class="form-control" placeholder="请输入歌曲名称" v-model="edit_song_name">
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">
					<span>歌星姓名</span>
					<i>*</i>
				</label>
				<div class="col-md-5">
					<input class="form-control" placeholder="请输入歌星姓名" v-model="edit_singer_name">
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">
					<span>歌曲文件</span>
					<i>*</i>
				</label>
				<div class="col-md-5">
					<input type="text" class="form-control input-readonly" placeholder="歌曲文件格式为：MP4，mkv，mpg" v-model="edit_file_name" readonly>
				</div>
				<button type="button" class="btn btn-flat btn-middle btn-orange" id="editFile">文件上传</button>
			</div>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backList">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="addSave">保存</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
				showList: true,

				query_field: "song_name",
				query_phd: "请输入歌曲名称",
				query_val: "",

				edit_song_name: '',
				edit_singer_name: '',
				edit_file_name: '',
				edit_file_url: '',
			}
		},
		watch: {
			
		},
		mounted: function() {
			const _this = this;

			_this.getShopData();
			// 处理结果
			$(_this.$refs.lack_status).select2({
				minimumResultsForSearch: -1,
				language: "zh-CN",
				width: '100%'
			});
			// 下拉选项
			$(_this.$refs.query_sel).select2({
				language: "zh-CN",
				minimumResultsForSearch: -1,
				width: '100px'
			}).change(function() {
				_this.query_field = $(this).val();
				_this.query_val = '';
				if(_this.query_field == 'song_name') {
					_this.query_phd = '请输入歌曲名称';
				} else if(_this.query_field == 'song_player') {
					_this.query_phd = '请输入歌星姓名';
				}
			});

			this.lackFileUpload();
		},
		methods: {
			// 门店
			getShopData: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						let arr = [];
						$.each(res.data.response.result, function(k, v) {
							arr.push({ id: v.id, text: v.name });
						});
						$(_this.$refs.lack_shop).select2({
							data: arr,
							language: "zh-CN",
							width: '100%'
						});
						_this.initTable();

						arr.shift();
						$(_this.$refs.edit_shop).select2({
							data: arr,
							language: "zh-CN",
							width: '100%'
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data["response"]["error_msg"]);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			// 初始化列表
			initTable: function() {
				const _this = this;

				$(_this.$refs.lack_list).bootstrapTable('destroy');
				$(_this.$refs.lack_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getLackList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "shop_name",
						title: "门店名称",
						width: "10%",
						valign: 'middle'
					}, {
						field: "create_time",
						title: "提交时间",
						width: "10%",
						valign: 'middle'
					}, {
						field: "song_name",
						title: "歌曲名称",
						width: "10%",
						valign: 'middle'
					}, {
						field: "song_player",
						title: "歌星姓名",
						width: "10%",
						valign: 'middle'
					}, {
						field: "file_name",
						title: "歌曲文件",
						width: "10%",
						valign: 'middle'
					}, {
						field: "status_name",
						title: "处理状态",
						width: "10%",
						valign: 'middle'
					}, {
						field: "reply_time",
						title: "处理时间",
						width: "10%",
						valign: 'middle'
					}, {
						field: "reply",
						title: "处理结果",
						width: "10%",
						valign: 'middle'
					}, {
						title: "操作",
						width: "10%",
						valign: 'middle',
						events: {
							'click .del': function(e, value, row, index) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_this.delLack(row.id);
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue del">删除</span>'
						}
					}]
				});
			},
			getLackList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let song_name = "",
					song_player = "";
				if(_this.query_field == 'song_name') {
					song_name = _this.query_val;
				} else if(_this.query_field == 'song_player') {
					song_player = _this.query_val;
				}
				_this.axios.post('Setting/getSongsOpinionList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $(_this.$refs.lack_shop).val(),
							"status": $(_this.$refs.lack_status).val(),
							"song_name": song_name,
							"song_player": song_player
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						params.success({
							total: res.data.response.result.count,
							rows: res.data.response.result.data
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			queryList: function() {
				this.initTable();
			},
			// 删除
			delLack(id) {
				const _this = this;

				Vue.axios.post('Setting/delSongsOpinion', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						$(_this.$refs.lack_list).bootstrapTable('refresh');
						layer.msg(res.data.response.error_msg);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 新增缺歌
			lackAdd() {
				$(this.$refs.lack_shop).val('').trigger('change');
				this.edit_song_name = '';
				this.edit_singer_name = '';
				this.edit_file_name = '';
				this.edit_file_url = '';
				this.showList = false;
			},
			// 歌曲文件上传
			lackFileUpload: function() {
				const _this = this;
				let host = '',
					dir = '',
					file_name = '';

				let layIndex;
				// 实例化一个plupload上传对象
				let uploader = new plupload.Uploader({
					browse_button: 'editFile', // 选择文件id
					filters: {
						mime_types: [ // 文件格式限制
							{ title: "files", extensions: "mp4,mkv,mpg" }
						],
						// max_file_size: '2mb', // 文件大小限制
						// prevent_duplicates: true // 不允许选取重复文件
					},
					multi_selection: false, // 单选
					url: "./", // OSS地址
					init: {
						// 文件上传前触发
						BeforeUpload: function(up, file) {
							layIndex = layer.load(2, {
								shade: [0.1, '#ececec']
							});
							// 获取签名
							let datas = {
								"header": Vue.request_header,
								"request": {
									"version": Vue.version,
									"param": {
										"file": file.name,
										"path": 'Setting'
									}
								},
								"comment": ""
							};
							let datas2 = JSON.stringify(datas);
							$.ajax({
								type: "POST",
								dataType: "json",
								url: Vue.ctUrl + "publicData/api_getOssSignature",
								async: false,
								crossDomain: true,
								xhrFields: {
									withCredentials: true
								},
								data: datas2,
								success: function(data) {
									if(data.response.result_code == "true") {
										host = data.response.data.host;
										dir = data.response.data.dir;
										file_name = data.response.data.file_name;
										let new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': data.response.data.accessid,
											'policy': data.response.data.policy,
											'signature': data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								},
								error: function(err) {
									layer.msg("出错啦");
								}
							});
						},
						// 文件选择完毕触发
						FilesAdded: function(up, file) {
							// 上传文件
							uploader.start();
						},
						// 文件上传成功触发
						FileUploaded: function(up, file, data) {
							_this.edit_file_name = file.name;
							_this.edit_file_url = host + "/" + dir + file_name;
							layer.close(layIndex);
							layer.msg('上传成功');
						},
						// 错误提示
						Error: function(up, err) {
							if(err.code == -600) {
								layer.msg('请选择2mb以内的文件');
							} else if (err.code == -601) {
								layer.msg('只允许上传mp4,mkv,mpg文件');
							} else if (err.code == -602) {
								layer.msg('这个文件已经上传过一遍了');
							} else {
								layer.msg(err.response);
							}
						}
					}
				});
				// 初始化
				uploader.init();
			},
			backList() {
				this.showList = true;
			},
			// 保存
			addSave() {
				const _this = this;

				Vue.axios.post('Setting/addSongsOpinion', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": $(_this.$refs.edit_shop).val(),
							"shop_name": $(_this.$refs.edit_shop).find("option:selected").text(),
							"song_name": _this.edit_song_name,
							"song_player": _this.edit_singer_name,
							"file_name": _this.edit_file_name,
							"file_url": _this.edit_file_url
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						$(_this.$refs.lack_list).bootstrapTable('refresh');
						layer.msg(res.data.response.error_msg);
						_this.showList = true;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			}
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.lack-manage-wrap {
		.lack-list {
			.lack-tit-sel {
				width: 100px;
				padding: 0;
			}
			.lack-con-val {
				padding-left: 0;
				margin-left: -1px;
			}
			.pull-right {
				button {
					margin: 0 0 0 30px;
				}
			}
		}
	}
</style>